import React, { useContext } from 'react';
import { StaticContext } from '@sm/webassets';
import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { PricingData } from './types';

import DetailsPackageHeader from '~pricing/components/DetailsTable/PackageHeader';
import Categories from '~app/pages/Pricing/components/DetailsTable/Categories';

import useDetailsStyles from './useStyles';

export default function DetailsPackagesView({ packageData }: PricingData): JSX.Element {
  const { Details, Sticky, Mobile, Desktop } = useDetailsStyles({
    packageCount: packageData.length,
  });

  const { ssrEnv } = useContext(StaticContext);

  if (!packageData) {
    return <></>;
  }

  return (
    <Box className={Details}>
      <Responsive maxWidth="md" defaultMatches={ssrEnv?.isMobile}>
        <Box className={Mobile}>
          {packageData.map((pricingPackage, index: number) => {
            const { comparisonSkuCost, skuCost, packageName } = pricingPackage;
            return (
              <div key={`Mobile-${packageName}`} className={`package-${packageName}`}>
                <DetailsPackageHeader
                  comparisonSkuCosts={comparisonSkuCost}
                  skuCosts={skuCost}
                  packageName={packageName}
                  index={`${index + 1}`}
                  data-testid="DetailsPackagesView__PackageHeader"
                />
                <Categories displayedPackages={[pricingPackage]} isMobile />
              </div>
            );
          })}
        </Box>
      </Responsive>

      <Responsive minWidth="md" defaultMatches={ssrEnv?.isDesktop}>
        <Box className={Desktop}>
          <Box className={Sticky} data-testid="DetailsPackagesView__Sticky">
            {packageData.map((pricingPackage, index: number) => {
              const { comparisonSkuCost, skuCost, packageName } = pricingPackage;
              return (
                <DetailsPackageHeader
                  key={`DetailsHeader-Desktop${packageName}`}
                  comparisonSkuCosts={comparisonSkuCost}
                  skuCosts={skuCost}
                  packageName={packageName}
                  index={`${index + 1}`}
                />
              );
            })}
          </Box>
          <Categories displayedPackages={packageData} />
        </Box>
      </Responsive>
    </Box>
  );
}
